<template>
  <div class="selecionar-empresa-list">
    <h2>Selecionar Empresa</h2>
    <v-list two-line>
      <template v-for="(item, index) in results">
        <v-list-tile
          :key="item.id"
          ripple
          @click="selectTaker(item)"
          :class="{
            inactive: !item.ativo || itemHasSameTakerId(item),
            'same-taker': itemHasSameTakerId(item),
          }"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ item.nome }}</strong>
              <v-chip label outline v-if="!item.ativo">Inativo</v-chip>
              <v-chip label outline v-if="itemHasSameTakerId(item)"
                >Já escolhido como tomador</v-chip
              >
            </v-list-tile-title>
            <v-list-tile-sub-title>{{
              item.endereco.logradouro
            }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="item.ativo && !itemHasSameTakerId(item)">
            <v-icon>keyboard_arrow_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="index + 1 < results.length" :key="index"></v-divider>
      </template>
    </v-list>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script lang="js">
export default {
  name: "SelecionarEmpresaList",
  props: ["results", "type", "idTomador"],
  methods: {
    itemHasSameTakerId(item) {
      return item.id == this.idTomador;
    },
    selectTaker(item) {
      if (!item.ativo || this.itemHasSameTakerId(item)) return;

      this.$emit("click", item);
    },
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/SelecionarEmpresaList.vue